import {
  PolicyRecommendation,
} from '../../graphQL/types/shared';

export const regularNodeRadius = 6;
export const highlightedNodeRadius = 16;

export const policyColors: Record<PolicyRecommendation, string> = {
  [PolicyRecommendation.ParsimoniousIndustrial]: '#C17A7A',
  [PolicyRecommendation.StrategicBets]: '#56B6CC',
  [PolicyRecommendation.LightTouch]: '#8EAA57',
  [PolicyRecommendation.TechFrontier]: '#8b86d0',
};
